import dayjs from "dayjs";

export const MONTH_NAMES: Record<string, string> = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec",
};

export const CHART_DEFAULT_COLOR_CHIP = {
  currentYear: {
    default: "#004AEB",
    backgroundColor: "rgba(0, 74, 235, 0.10)",
    stroke: "#A3C0FF",
  },
  lastYear: {
    default: "#1BAEFE",
    area: "#1BAEFE",
    backgroundColor: "#E8F7FF",
    stroke: "#76CFFE",
    dot: "#1BAEFE",
  },
};

export const YEAR_INFO = {
  lastYear: dayjs().subtract(1, "year").year(),
  lastYear2: dayjs().subtract(2, "year").year(),
  lastYear3: dayjs().subtract(3, "year").year(),
  currentYear: dayjs().year(),
};
